import { FechaFunctionsService } from '@/utils/functions.service';
import { formatPedidoFolio } from '@/utils/pedido-folio';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TicketGlobalComponent } from '@components/ticket-global/ticket-global.component';
import { TicketComponent } from '@components/ticket/ticket.component';
import { AppService } from '@services/app.service';
import { GeneralService } from '@services/general.service';
import { GlobalTicketService } from '@services/global-ticket-service.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.scss']
})
export class PedidoComponent {
  pedidoForm: FormGroup;
  productoForm: FormGroup;
  clientes: Array<any>;
  productos: Array<any>;
  @ViewChild('ticket') ticket: TicketComponent;
  @ViewChild('ticketGlobal') ticketGlobal!: TicketGlobalComponent;
  isEditable = {};
  isEditablePayment = {};
  listaProductos: Array<any> = [];
  listaMetodoPago: Array<any> = [];
  listaDirecciones: Array<any> = [];
  idPedido: number = null;
  /** Folio visible (numero_pedido); idPedido sigue siendo la clave interna. */
  pedidoFolio: string = '';
  TotalProductos: number = 0;
  currencySumm: number = 0;
  currencySummAux: number = 0;
  currencyAbono: number = 0;
  currencyDespacho: number = 0;
  id_cliente: number = null;
  despachoSimple: any;
  despachoDoble: any;
  originUrl: string;
  readOnlyDespacho: boolean = true
  AuxRow = [];

  constructor(private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    public Func: FechaFunctionsService,
    public appService: AppService,
    private globalTicket: GlobalTicketService,
    public loadingService: LoadingService,
    private cdr: ChangeDetectorRef) {
  }

  async ngOnInit() {
    this.loadingService.setLoading(true); // 🔹 Muestra el spinner antes de comenzar

    try {
      await Promise.all([
        this.getProductos(),
        this.getProductosDespachos(),
        this.getClientes()
      ]);
      await this.initializeForm();
      this.initializeFormProduct();
      // 🔸 Forzamos la detección de cambios para asegurar que la vista se actualiza
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error al cargar los datos:', error);
    } finally {
      this.loadingService.setLoading(false); // 🔹 Oculta el spinner al terminar (éxito o error)
    }
  }

  onlyNumber(e: any) {
    const regExp = /[^0-9]+/g;
    e.target.value = e.target.value.replace(regExp, '');
  }

  async initializeForm() {
    try {
      const idPedidoStored = localStorage.getItem('idPedido');

      if (idPedidoStored) {
        this.idPedido = Number(idPedidoStored);

        const res = await this.generalService.getObtiene("pedido", this.idPedido, "detalle");
        const pedido = res.data;
        this.pedidoFolio = formatPedidoFolio(pedido);

        // Procesar detalle de pedidos
        for (const e of pedido.detalle_pedidos) {
          const producto = {
            id_producto: e.producto.id_producto,
            nombre_producto: e.producto.nombre,
            procesamiento: e.producto.procesamiento,
            valor: e.valor,
            cantidad: e.cantidad,
          };
          this.addProduct(producto);
        }

        // Procesar detalle de pagos
        for (const e of pedido.detalle_pagos) {
          const metodoPago = {
            fecha_pago: this.Func.DateFormated(e.fecha_pago),
            hora_pago: e.hora_pago,
            id_tipopago: e.tipo_pago.id_tipopago,
            tipoPagoText: e.tipo_pago.nombre_tipopago,
            referencia: e.referencia,
            total: e.valor,
          };
          this.listaMetodoPago.push(metodoPago);
        }

        this.calculaAbono();
        await this.findCliente(pedido.id_cliente);

        // Construcción del formulario con datos existentes
        this.pedidoForm = this.fb.group({
          id_pedido: [this.idPedido, Validators.required],
          id_cliente: [pedido.id_cliente, Validators.required],
          nombre_cliente: [pedido.cliente.nombre_completo, Validators.required],
          fechaIngreso: [this.Func.DateFormated(pedido.fecha_ingreso), Validators.required],
          fecha_termino: [this.Func.DateFormated(pedido.fecha_termino), Validators.required],
          observacion: [pedido.observacion],
          id_estado: [pedido.id_estado],
          productos: [this.listaProductos],
          metodoPago: [this.listaMetodoPago],
          is_pickup: [pedido.is_pickup],
          fecha_pickup: [pedido.fecha_pickup],
          id_direccion_pickup: [pedido.id_direccion_pickup],
          is_delivery: [pedido.is_delivery],
          fecha_delivery: [pedido.fecha_delivery],
          id_direccion_delivery: [pedido.id_direccion_delivery],
          ref: [null],
          valor: [null],
          tipo_descuento: [pedido.tipo_descuento],
          descuento: [pedido.descuento],
          valor_despacho: [pedido.valor_despacho]
        });

        this.currencyDespacho = pedido.valor_despacho;
        this.reloadTable();
      }
      else {
        // Si no hay idPedido en localStorage → formulario nuevo
        this.pedidoForm = this.createEmptyPedidoForm();
      }

    } catch (error) {
      console.error("Error en initializeForm:", error);
      this.idPedido = null;
      this.pedidoFolio = '';
      this.pedidoForm = this.createEmptyPedidoForm();
    }
  }

  /** 🧩 Función auxiliar para limpiar duplicación **/
  private createEmptyPedidoForm(): FormGroup {
    return this.fb.group({
      id_pedido: [null],
      id_cliente: [null, Validators.required],
      nombre_cliente: [null, Validators.required],
      fechaIngreso: [this.Func.NowDayFormated(), Validators.required],
      fecha_termino: [this.Func.addDays(new Date(), 4), Validators.required],
      observacion: [null],
      id_estado: [1],
      productos: [this.listaProductos],
      metodoPago: [this.listaMetodoPago],
      is_pickup: [false],
      fecha_pickup: [null],
      id_direccion_pickup: [null],
      is_delivery: [false],
      fecha_delivery: [null],
      id_direccion_delivery: [null],
      ref: [null],
      valor: [null],
      tipo_descuento: ["$"],
      descuento: [0],
      valor_despacho: [0]
    });
  }


  initializeFormProduct() {
    this.productoForm = this.fb.group({
      id_producto: [null, Validators.required],
      nombre_producto: [null, Validators.required],
      procesamiento: [null, Validators.required],
      valor: [null, Validators.required],
      cantidad: [1, Validators.required]
    });
  }

  onSelectItem(item) {
    if (item == null) {
      this.productoForm.get('id_producto').setValue(null);
      this.productoForm.get('valor').setValue(null);
      this.productoForm.get('procesamiento').setValue(null);
      return
    }
    this.productoForm.get('id_producto').setValue(item.id_producto);
    this.productoForm.get('valor').setValue(item.valor);
    this.productoForm.get('procesamiento').setValue(item.procesamiento);
  }

  async onSelectItemCliente(item) {
    if (item == null) {
      this.id_cliente = null
      this.pedidoForm.get('id_cliente').setValue(null);
      this.listaDirecciones = []
      return
    }
    this.id_cliente = item.id_cliente
    this.pedidoForm.get('id_cliente').setValue(item.id_cliente);
    await this.findCliente(item.id_cliente)
  }

  async addProduct(form) {
    this.loadingService.setLoading(true); // 🔹 Muestra el spinner antes de comenzar
    try {
      this.listaProductos.push(form)
      this.initializeFormProduct();
      this.reloadTable();
    } catch (error) {
      console.error('Error al cargar los datos:', error);
    } finally {
      this.loadingService.setLoading(false); // 🔹 Oculta el spinner al terminar (éxito o error)
    }
  }

  formatPaymentsForBD() {
    return this.listaMetodoPago.map(pago => ({
      ...pago,
      valor: Number(pago.total),
      fecha_pago: this.Func.DateFormatedBD(pago.fecha_pago)
    }));
  }

  async SaveButton(form) {
    this.loadingService.setLoading(true);
    if (this.idPedido == null) {
      this.generalService
        .postCrear("pedido/pedidos-completos", {
          "pedido": {
            "fecha_termino": this.Func.DateFormatedBD(form.fecha_termino),
            "subtotal_venta": this.currencySumm,
            "tipo_descuento": form.tipo_descuento,
            "descuento": form.descuento,
            "valor_despacho": this.currencyDespacho,
            "total_venta": this.currencySumm + this.currencyDespacho,
            "id_cliente": form.id_cliente,
            "observacion": form.observacion ? form.observacion.replace(/(\r\n|\r|\n)/g, '<br>') : "",
            "id_estado": (form.is_pickup) ? 2 : form.id_estado,
            "is_pickup": form.is_pickup,
            "fecha_pickup": form.fecha_pickup ? this.Func.DateFormatedBD(form.fecha_pickup) : null,
            "id_direccion_pickup": form.id_direccion_pickup,
            "is_delivery": form.is_delivery,
            "fecha_delivery": form.fecha_delivery ? this.Func.DateFormatedBD(form.fecha_delivery) : null,
            "id_direccion_delivery": form.id_direccion_delivery
          },
          "detalles": this.listaProductos,
          "pagos": this.formatPaymentsForBD()
        }).then(async res => {
          /* this.generalService
            .postCrear("detalle_pedido", { id_pedido: res.data.id_pedido, productos: this.listaProductos })
          this.generalService
            .postCrear("detalle_pago", { id_pedido: res.data.id_pedido, metodoPago: this.listaMetodoPago }) */

          this.toastr.success('Pedido creado con exito!')
          await setTimeout(() => {
            // Abrir el modal de manera independiente
            this.ticketGlobal.open(res.data.id_pedido);
          }, 2000);
          await setTimeout(() => {
            window.history.back();
            this.loadingService.setLoading(false);
            /* this.ticket.idPedido = res.data.id_pedido;
            this.ticket.open(); */
            localStorage.removeItem('idPedido');
          }, 1000);
        })
        .catch(err => {
          this.toastr.error('Error al crear pedido!');
          this.loadingService.setLoading(false);
        });
    }
    else {
      this.generalService
        .putEdita("pedido/pedidos-completos", this.idPedido, {
          "pedido": {
            "fecha_termino": this.Func.DateFormatedBD(form.fecha_termino),
            "subtotal_venta": this.currencySumm,
            "tipo_descuento": form.tipo_descuento,
            "descuento": form.descuento,
            "valor_despacho": this.currencyDespacho,
            "total_venta": this.currencySumm + this.currencyDespacho,
            "id_cliente": form.id_cliente,
            "observacion": form.observacion.replace(/(\r\n|\r|\n)/g, '<br>'),
            "id_estado": form.id_estado,
            "is_pickup": form.is_pickup,
            "fecha_pickup": form.fecha_pickup ? this.Func.DateFormatedBD(form.fecha_pickup) : null,
            "id_direccion_pickup": form.id_direccion_pickup,
            "is_delivery": form.is_delivery,
            "fecha_delivery": form.fecha_delivery ? this.Func.DateFormatedBD(form.fecha_delivery) : null,
            "id_direccion_delivery": form.id_direccion_delivery
          },
          "detalles": this.listaProductos,
          "pagos": this.formatPaymentsForBD()
        }).then(async res => {
          /* this.generalService
            .putEdita("detalle_pedido", this.idPedido, { productos: this.listaProductos })
          this.generalService
            .putEdita("detalle_pago", this.idPedido, { metodoPago: this.listaMetodoPago }) */
          this.toastr.success('Pedido actualizado con exito!')

          await setTimeout(() => {
            // Abrir el modal de manera independiente
            this.ticketGlobal.open(this.idPedido);
          }, 2000);
          await setTimeout(() => {
            window.history.back();
            this.loadingService.setLoading(false);
            /* this.ticket.idPedido = this.idPedido;
            this.ticket.open(); */
            localStorage.removeItem('idPedido');
          }, 1000);
        })
        .catch(err => {
          this.toastr.error('Error al actualizar pedido!');
          this.loadingService.setLoading(false);
        });
    }
  }

  async getClientes() {
    try {
      let res = await this.generalService.getListar("cliente/onlyname?habilitado=1")
      this.clientes = res.data;
    } catch (error) {
      this.clientes = null
    }
  }

  async findCliente(idCliente) {
    try {
      let res = await this.generalService.getObtiene("cliente", idCliente)
      this.listaDirecciones = res.data.direccions;
    } catch (error) {
      this.listaDirecciones = null
    }
  }

  async getProductos() {
    try {
      let res = await this.generalService.getListar("producto/all?habilitado=1")
      this.productos = res.data;
    } catch (error) {
      this.productos = null
    }
  }

  edit(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex]
    this.AuxRow[rowIndex] = { ...row };
  }

  save(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex]
    this.listaProductos[rowIndex] = row;
    this.AuxRow[rowIndex] = null;
    this.reloadTable();
  }

  // Delete row
  delete(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    this.listaProductos.splice(rowIndex, 1);
    this.AuxRow[rowIndex] = null;
    this.reloadTable();
  }

  cancel(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex]
    this.listaProductos[rowIndex] = this.AuxRow[rowIndex];
    this.AuxRow[rowIndex] = null;
    this.reloadTable();
  }

  verifyEdit() {
    return !this.AuxRow.every((element) => element === null)
  }

  emptyTable() {
    this.listaProductos = [];
    this.reloadTable();
  }

  ChangeTipoDscto() {
    this.pedidoForm.get('descuento').setValue(0)
    this.reloadTable()
  }

  reloadTable() {
    //this.table.rows = this.listaProductos;
    let total = 0;
    this.listaProductos.forEach((item) => {
      total = total + (item.valor * item.cantidad);
    });
    this.TotalProductos = total;
    this.currencySumm = total;
    this.currencySummAux = 0
    let descuento = this.pedidoForm.get('descuento').value
    let tipo_descuento = this.pedidoForm.get('tipo_descuento').value
    this.currencyDespacho = Number(this.pedidoForm.get('valor_despacho').value)
    if (descuento != 0) {
      this.currencySummAux = total;
      switch (tipo_descuento) {
        case "$":
          this.currencySumm = Math.round(this.currencySummAux - descuento)
          break;
        case "%":
          this.currencySumm = Math.round(this.currencySummAux - (this.currencySummAux * (descuento / 100)))
          break;
        default:
          break;
      }
    }
  }

  savePayment(row, rowIndex) {
    this.isEditablePayment[rowIndex] = !this.isEditablePayment[rowIndex]
    this.listaMetodoPago[rowIndex] = row;
    this.calculaAbono();
  }

  // Delete row
  deletePayment(row, rowIndex) {
    this.isEditablePayment[rowIndex] = !this.isEditablePayment[rowIndex];
    this.listaMetodoPago.splice(rowIndex, 1);
    this.calculaAbono();
  }

  updateMetodoPago(form) {
    this.listaMetodoPago.push(form);
    this.calculaAbono();
  }

  calculaAbono() {
    let abono = 0;
    this.listaMetodoPago.forEach((e) => {
      abono = abono + Number(e.total)
    })
    this.currencyAbono = abono
  }

  async ChangeCheckPickup(event) {
    this.loadingService.setLoading(true)
    try {
      this.checkItems();
      if (this.pedidoForm.get('is_pickup').value == true) {
        this.pedidoForm.get('id_direccion_pickup').addValidators(Validators.required)
        this.pedidoForm.get('fecha_pickup').setValue(this.pedidoForm.get('fecha_ingreso').value)
      }
      else {
        this.pedidoForm.get('id_direccion_pickup').clearValidators()
        this.pedidoForm.get('fecha_pickup').setValue(null)
        this.pedidoForm.get('id_direccion_pickup').setValue(null)
      }
    } catch (error) {
      this.loadingService.setLoading(false)
    } finally {
      this.loadingService.setLoading(false); // 🔹 Oculta el spinner al terminar (éxito o error)
    }
  }

  async ChangeCheckDelivery(event) {
    this.loadingService.setLoading(true)
    try {
      this.checkItems();
      if (this.pedidoForm.get('is_delivery').value == true) {
        this.pedidoForm.get('id_direccion_delivery').addValidators(Validators.required)
        this.pedidoForm.get('fecha_delivery').setValue(this.pedidoForm.get('fecha_termino').value)
      }
      else {
        this.pedidoForm.get('id_direccion_delivery').clearValidators()
        this.pedidoForm.get('fecha_delivery').setValue(null)
        this.pedidoForm.get('id_direccion_delivery').setValue(null)
      }
    } catch (error) {
      this.loadingService.setLoading(false)
    } finally {
      this.loadingService.setLoading(false); // 🔹 Oculta el spinner al terminar (éxito o error)
    }
  }

  checkItems() {
    this.listaProductos.forEach((item, index) => {
      if (item.id_producto == this.despachoSimple.id_producto || item.id_producto == this.despachoDoble.id_producto) {
        this.listaProductos.splice(index, 1);
      }
    });
    this.currencyDespacho = 0;
    if (this.pedidoForm.get('is_pickup').value == true && this.pedidoForm.get('is_delivery').value == false) {
      this.currencyDespacho = this.despachoSimple.valor
    }
    if (this.pedidoForm.get('is_pickup').value == false && this.pedidoForm.get('is_delivery').value == true) {
      this.currencyDespacho = this.despachoSimple.valor
    }
    if (this.pedidoForm.get('is_pickup').value == true && this.pedidoForm.get('is_delivery').value == true) {
      this.currencyDespacho = this.despachoDoble.valor
    }
    this.pedidoForm.get('valor_despacho').setValue(this.currencyDespacho)
    this.reloadTable();
  }

  async updateDataDireccionPickup(event) {
    await this.findCliente(this.pedidoForm.get('id_cliente').value)
    this.pedidoForm.get('id_direccion_pickup').setValue(event)
  }

  async updateDataDireccionDelivery(event) {
    await this.findCliente(this.pedidoForm.get('id_cliente').value)
    this.pedidoForm.get('id_direccion_delivery').setValue(event)
  }

  async getProductosDespachos() {
    try {
      let res = await this.generalService.getListar("producto/delivery")
      this.despachoSimple = res.data.find(e => e.isDespacho === 1);
      this.despachoDoble = res.data.find(e => e.isDespacho === 2);

    } catch (error) {
    }
  }
}
